export default "__VITE_ASSET__fc9a404e__"